/* ==========================================================================
   KĀRU · Blog-Bausteine JS
   --------------------------------------------------------------------------
   Baut das Inhaltsverzeichnis automatisch: scannt die Überschriften im
   Artikel-Body, vergibt (fehlende) IDs und füllt die TOC-Liste.

   Warum JS? Der Shopify-Rich-Text-Editor entfernt `id`-Attribute an
   Überschriften -> Anker-Links würden brechen. Diese Logik vergibt die IDs
   zur Laufzeit neu, robust und ohne Handarbeit pro Artikel.

   Markup-Vertrag:
     <nav class="mk-toc" data-mk-toc data-mk-toc-levels="h2">
       <p class="mk-toc__title">…</p>
       <ol data-mk-toc-list></ol>
     </nav>
     <div class="article__content">…{{ article.content }}…</div>
   ========================================================================== */
(function () {
  'use strict';

  function slugify(text) {
    return (text || '')
      .toLowerCase()
      .trim()
      .replace(/['"„“”»«]/g, '')
      .replace(/[äàáâ]/g, 'a')
      .replace(/[öòóô]/g, 'o')
      .replace(/[üùúû]/g, 'u')
      .replace(/ß/g, 'ss')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 60) || 'abschnitt';
  }

  function buildToc(toc) {
    var list = toc.querySelector('[data-mk-toc-list]');
    if (!list) return;

    var content =
      document.querySelector(toc.getAttribute('data-mk-toc-target') || '.article__content');
    if (!content) {
      toc.hidden = true;
      return;
    }

    var levels = (toc.getAttribute('data-mk-toc-levels') || 'h2')
      .split(',')
      .map(function (s) { return s.trim().toLowerCase(); })
      .filter(Boolean)
      .join(',');

    var headings = content.querySelectorAll(levels);
    var used = {};
    var frag = document.createDocumentFragment();
    var count = 0;

    headings.forEach(function (h) {
      var text = h.textContent.trim();
      if (!text) return;

      // Skip Überschriften, die explizit ausgeschlossen sind
      if (h.hasAttribute('data-toc-skip')) return;

      // Baustein-interne Überschriften (z. B. "Das Wichtigste in Kürze") nicht
      // ins Inhaltsverzeichnis aufnehmen – nur echte Content-H2.
      if (h.closest('.mk-takeaways, .mk-info, .mk-tipp, .mk-steps, .mk-product, .mk-cta, .mk-faq')) return;
      if (h.classList.contains('mk-faq__heading') || h.classList.contains('mk-product__section-title')) return;

      var id = h.id;
      if (!id) {
        id = slugify(text);
        var base = id;
        var n = 2;
        while (used[id] || document.getElementById(id)) {
          id = base + '-' + n++;
        }
        h.id = id;
      }
      used[id] = true;

      var li = document.createElement('li');
      if (h.tagName.toLowerCase() !== 'h2') {
        li.className = 'mk-toc__sub';
      }
      var a = document.createElement('a');
      a.href = '#' + id;
      a.textContent = text;
      li.appendChild(a);
      frag.appendChild(li);
      count++;
    });

    if (count === 0) {
      toc.hidden = true;
      return;
    }

    list.appendChild(frag);
    toc.hidden = false;

    // Sanftes Scrollen mit Offset (scroll-margin-top übernimmt den Abstand)
    list.addEventListener('click', function (e) {
      var link = e.target.closest('a[href^="#"]');
      if (!link) return;
      var target = document.getElementById(decodeURIComponent(link.hash.slice(1)));
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      if (history.replaceState) {
        history.replaceState(null, '', link.hash);
      }
    });
  }

  function init() {
    document.querySelectorAll('[data-mk-toc]').forEach(buildToc);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
